import React from 'react';
import { MapPinIcon } from 'lucide-react';
const Coverage = () => {
  const areas = [{
    region: 'El Progreso',
    locations: ['Guastatoya', 'El Rancho', 'San Agustín Acasaguastlán (Cabecera Municipal)']
  }, {
    region: 'Zacapa',
    locations: ['Cabecera Departamental', 'San Jorge', 'Estanzuela', 'Río Hondo']
  }, {
    region: 'Chiquimula',
    locations: ['Cabecera Departamental', 'Residenciales Adyacentes']
  }];
  return <section id="cobertura" className="py-16 bg-white" data-id="element-22">
      <div className="container mx-auto px-4" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-25">
            Áreas de Cobertura
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-26">
            Actualmente servimos el oriente del país, llevando agua purificada a
            las principales cabeceras departamentales y municipios.
          </p>
        </div>
        <div className="flex flex-col md:flex-row items-start" data-id="element-27">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-10" data-id="element-28">
            <div className="bg-blue-50 p-6 rounded-xl" data-id="element-29">
              <h3 className="text-xl font-semibold text-gray-800 mb-6" data-id="element-30">
                Zonas con servicio
              </h3>
              {areas.map((area, index) => <div key={index} className="mb-6 last:mb-0" data-id="element-31">
                  <h4 className="font-semibold text-[#2d98e2] mb-2" data-id="element-32">
                    {area.region}
                  </h4>
                  <div className="grid grid-cols-1 gap-2" data-id="element-33">
                    {area.locations.map((location, locationIndex) => <div key={locationIndex} className="flex items-center" data-id="element-34">
                        <MapPinIcon size={16} className="text-[#2d98e2] mr-2 flex-shrink-0" data-id="element-35" />
                        <span className="text-gray-600" data-id="element-36">{location}</span>
                      </div>)}
                  </div>
                </div>)}
              <div className="mt-6" data-id="element-37">
                <button className="bg-[#2d98e2] hover:bg-[#146ead] text-white font-medium py-2 px-4 rounded-lg transition-colors w-full" data-id="element-38">
                  Verificar mi dirección
                </button>
              </div>
            </div>
          </div>
          <div className="md:w-1/2" data-id="element-39">
            <div className="bg-white p-4 rounded-xl shadow-lg" data-id="element-40">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/be5VkQHAN2hxY4EY1TiwxS/MAPA_DE_COBERTURA.png" alt="Mapa de cobertura Guaterflow - Región Oriental" className="w-full h-auto rounded-lg" data-id="element-41" />
              <p className="text-sm text-gray-500 mt-2 text-center" data-id="element-42">
                Región Oriental de Guatemala - Área de Cobertura Guaterflow
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Coverage;